import { IconV1 } from 'common/icon/iconV1.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { CellRenderType, ComponentTester } from './renderCell.js';

export const RenderCellLink: ComponentTester<CellRenderType.link> = ({ data }) => {
  if (data?.icon) {
    return (
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyCenter">
        <IconV1 icon={data.icon} size={32} iconClass="svg--1em " />
      </div>
    );
  }
  messageLog.warning('No cell render props');
  return <div style={{ minWidth: '80px' }} />;
};
